import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadQidDatapointsByFailureMode,
    DeleteQidModelFailureMode,
    setQidModelDeleteFailureMode,
    setQidModelReloadList,
    setQidDatapointReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
    Loader,
} from "client/components"


export const ConfirmDeleteFailureMode = () => {
    const failureMode = useSelector((state: StoreType) => state.qidModel.deleteFailureMode)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [datapoints, setDatapoints] = useState<number>(0)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!failureMode) return
        setLoadState(PENDING)
        LoadQidDatapointsByFailureMode(failureMode.id).then((res) => {
            setDatapoints(res.length)
            setLoadState(IDLE)
        })
    }, [failureMode])

    const onCancel = () => {
        dispatch(setQidModelDeleteFailureMode(null))
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        DeleteQidModelFailureMode(failureMode.id).then(() => {
            setDeleteState(IDLE)

            dispatch(setQidModelDeleteFailureMode(null))

            dispatch(setQidModelReloadList(false))
            dispatch(setQidDatapointReloadList(false))
            setTimeout(() => {
                dispatch(setQidModelReloadList(true))
                dispatch(setQidDatapointReloadList(true))
            }, 0)
        })
    }

    return (
        <ConfirmWrapper show={!!failureMode} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{failureMode ? failureMode.name : ""}</ConfirmTitle>
                <ConfirmDescription>
                    {
                        loadState === PENDING
                            ? <Loader />
                            : (datapoints > 0 ? lang.deleteFailureModeDatapointsConfirm : lang.deleteFailureModeConfirm)
                    }
                </ConfirmDescription>

                <ConfirmBottom>
                    <Button variant="success" row disabled={deleteState === PENDING} onClick={onConfirmDelete}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeleteFailureMode
